import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import SourcingAgent from './SourcingAgent';
import { useAuth } from '../../contexts/AuthContext';

const SourcingSessionPage = () => {
  const { jobId, sessionId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const [session, setSession] = useState(location.state?.session || null);
  const [loading, setLoading] = useState(!session);
  const [error, setError] = useState('');

  // Gate check & redirect when feature is disabled
  useEffect(() => {
    if (user && user.features?.sourcing !== true) {
      navigate(`/dashboard/job-posts/jobs/${jobId}/sourcing`, { replace: true });
    }
  }, [user, jobId, navigate]);

  // Hide parent scroll and padding when this page is mounted
  useEffect(() => {
    const main = document.getElementById('main-content');
    if (main) {
      main.style.overflow = 'hidden';
      main.style.padding = '0';
    }
    return () => {
      if (main) {
        main.style.overflow = '';
        main.style.padding = '';
      }
    };
  }, []);

  useEffect(() => {
    if (session) return;
    const fetchSession = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`/api/coresignal/history?jobId=${jobId}`);
        const found = (res.data || []).find(s => s._id === sessionId);
        if (found) {
          setSession(found);
        } else {
          setError('Session not found.');
        }
      } catch (e) {
        setError('Failed to load sourcing session.');
      } finally {
        setLoading(false);
      }
    };
    fetchSession();
  }, [jobId, sessionId, session]);

  if (user && user.features?.sourcing !== true) {
    return null;
  }

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full w-full min-h-[60vh]">
        <div className="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-[#007BFF]" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col items-center justify-center h-full w-full min-h-[60vh] gap-3">
        <p className="text-sm font-semibold text-red-500">{error}</p>
        <button onClick={() => navigate(`/dashboard/job-posts/jobs/${jobId}/sourcing`)}
          className="text-sm text-[#007BFF] hover:underline">
          ← Back to Sourcing
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full h-screen overflow-hidden">
      <SourcingAgent
        jobId={jobId}
        mode="detail"
        initialSession={session}
        onClose={() => navigate(`/dashboard/job-posts/jobs/${jobId}/sourcing`)}
      />
    </div>
  );
};

export default SourcingSessionPage;
